import { j as n } from "./atoms-v218.js";
import { forwardRef as $, useMemo as g } from "react";
import { AccordionItem as p, Toggle as x, Disclosure as f, Content as u } from "./atoms-v21228.js";
const j = $(
  ({ children: s, className: l, contentClassName: i, disabled: r = !1, id: o, isOpen: t, label: c, onToggle: a }, m) => {
    const e = g(() => o || crypto && (crypto == null ? void 0 : crypto.randomUUID()), [o]), d = () => {
      a && a(o);
    };
    return /* @__PURE__ */ n.jsxs(p, { $isOpen: t, className: l, id: o, ref: m, children: [
      /* @__PURE__ */ n.jsxs(
        x,
        {
          $isOpen: t,
          "aria-controls": `${e}_content`,
          "aria-expanded": t,
          "aria-label": `Toggle “${c}” content.`,
          "data-testid": `${o}_toggle`,
          disabled: r,
          id: `${e}_toggle`,
          onClick: d,
          type: "button",
          children: [
            c,
            r ? null : /* @__PURE__ */ n.jsx(f, { $isOpen: t, name: "chevron-down", size: "medium" })
          ]
        }
      ),
      /* @__PURE__ */ n.jsx(
        u,
        {
          $isOpen: t,
          "aria-labelledby": `${e}_toggle`,
          className: i,
          "data-testid": `${o}_content`,
          id: `${e}_content`,
          role: "region",
          children: s
        }
      )
    ] });
  }
);
j.displayName = "AccordionItem";
export {
  j as AccordionItem
};
